import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';

const styles = () =>
  createStyles({
    playerContainer: {
      width: '100%',
      height: '100%'
    }
  });
interface IVideoJsPlayer extends WithStyles<typeof styles> {
  src: string;
}
declare var Plyr;
declare var Hls;
class VideoJsPlayer extends Component<IVideoJsPlayer> {
  videoNode: any;
  player: any;
  videoSrc: any;
  hls: any;
  constructor(props: IVideoJsPlayer) {
    super(props);
    this.player = React.createRef();
  }

  componentDidMount() {
    let urlTokens = [];
    if (this.props.src) {
      urlTokens = this.props.src.split('.');
      if (
        this.props.src &&
        urlTokens &&
        urlTokens[urlTokens.length - 1] === 'm3u8'
      ) {
        window.localStorage.removeItem('plyr');
        this.hls = new Hls({
          enableWorker: true,
          liveBackBufferLength: 0,
          backBufferLength: 15,
          liveMaxBackBufferLength: 0,
          maxBufferSize: 0,
          maxBufferLength: 10,
          liveSyncDurationCount: 1
        });
        this.hls.loadSource(this.props.src);
        this.hls.attachMedia(this.videoNode);
        this.hls.on(Hls.Events.MANIFEST_PARSED, function() {
          this.videoNode.play();
        });

        this.player = new Plyr(this.videoNode, {
          autoplay: true,
          muted: true,
          controls: [
            'play-large',
            'play',
            'progress',
            'current-time',
            'mute',
            'volume',
            'captions',
            'settings',
            'airplay',
            'fullscreen'
          ]
        });
      } else {
        this.player = new Plyr('.js-plyr', {
          autoplay: true,
          muted: true,
          controls: [
            'play-large',
            'play',
            'progress',
            'current-time',
            'mute',
            'volume',
            'captions',
            'settings',
            'airplay',
            'fullscreen'
          ]
        });
        this.player.source = {
          type: 'video',
          sources: [{ src: this.props.src }]
        };
      }
    }
  }

  componentWillUnmount() {
    if (this.player) {
      this.hls.destroy();
      this.player.destroy();
    }
  }

  render() {
    return (
      <div className={this.props.classes.playerContainer}>
        <video className="js-plyr plyr" ref={node => (this.videoNode = node)} />
      </div>
    );
  }
}

export default withStyles(styles)(VideoJsPlayer);
